import { MediaRef } from '$/GraphQL/schema/types';

export const isImageUrl = async (url: string): Promise<boolean> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = (): void => resolve(true);
    img.onerror = (): void => resolve(false);
    img.src = url;
  });
};

export const base64ToFile = async (base64Url: string): Promise<File> => {
  return new Promise((resolve, reject) => {
    void (async function () {
      const res = await isImageUrl(base64Url);
      if (res) {
        try {
          fetch(base64Url)
            .then((response) => {
              response.arrayBuffer().then(function (buffer) {
                const file = new Blob([buffer]) as File;
                resolve(file);
              });
            })
            .catch((err) => {
              reject(err.toString());
            });
        } catch (e) {
          const error = e as Error;
          reject(String(error));
        }
      }
    })();
  });
};

export const getOriginalSizeImage = async (
  url: string
): Promise<{
  height: number;
  width: number;
}> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = (): void => resolve({ height: img.height, width: img.width });
    img.onerror = (): void => resolve({ height: 1, width: 1 });
    img.src = url;
  });
};

export function cssDimensionsForRef(
  ref: MediaRef | undefined | null,
  css: { maxWidth: number; maxHeight?: number }
): string {
  let dimensions = '';

  if (ref && ref.width && ref.height && css.maxHeight && ref.fit === 'contain') {
    const ratio = ref.width / ref.height;
    let height;
    let width;
    if (ratio > 1) {
      // landscape
      width = Math.min(css.maxWidth, ref.width);
      height = width / ratio;
    } else {
      // portrait
      height = Math.min(css.maxHeight ?? 10000000000000, ref.height);
      width = height * ratio;
    }
    dimensions = `width: ${width}px; height: ${height}px;`;
  }

  return `
    max-width: ${css.maxWidth}px;
    max-height: ${css.maxHeight}px;
    ${dimensions}
  `;
}
